import PageStyle from "@/styles/components/request-for-more/_index.module.scss";
import Button from "@/components/button";
import Modal from "./common-modal/modal";
import { useTranslation } from "react-i18next";

export function OfferRejectedReasons({
  offerRejectedReasons,
  setOfferRejectReasons,
}) {
  const {t} = useTranslation()
  return (
    <Modal
      type="info"
      closeModal={() => setOfferRejectReasons({ state: false })}
      heading={
        offerRejectedReasons?.heading == "Rejection Reason"
          ? t('modal:info:offer:rejection:reason')
          :  t('modal:info:offer:rejection:rejected')
      }
      description={
        offerRejectedReasons?.heading == "Rejection Reason"
          ? ""
          :  t('modal:info:offer:rejection:description')
      }
      innerContent={
        <>
          {offerRejectedReasons.reasons.map((reason) => {
            return (
              <p className={`${PageStyle.SetupPopup__PopDetails} mt15`}>
                {reason}
              </p>
            );
          })}
        </>
      }
    />
  );
}
